export default __webpack_public_path__ + "static/media/Mask-Group.55794ee9.png";